interface LLTextAreaProps {
  labelText?: string;
  minHeight?: string;
  maxLength?: number;
  resize?: React.CSSProperties['resize'];
}

const LLTextArea: React.FC<
  React.InputHTMLAttributes<HTMLTextAreaElement> & LLTextAreaProps
> = ({
  placeholder,
  id,
  labelText,
  minHeight,
  maxLength,
  resize,
  value,
  onChange,
}) => {
  if (!labelText) {
    labelText = placeholder;
  }

  return (
    <div className="form-floating">
      <textarea
        id={id}
        className="form-control"
        placeholder={placeholder}
        maxLength={maxLength}
        style={{ minHeight, resize }}
        value={value}
        onChange={onChange}
      ></textarea>
      <label htmlFor={id}>{labelText}</label>
    </div>
  );
};

export default LLTextArea;
